import React, { useMemo } from "react";
import {
  Typography,
  DialogTitle,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  styled,
} from "@mui/material";
import { IconBackgroundDelete, DeleteIcon } from "components/icon";
import { Close as CloseIcon } from "components/icon/mui_icon";
import { StyledDialog } from "customStyled";
import { DynamicAvatar, FormFooter } from "Reuse/UI";
import FormInputUI from "components/Form/UI/FormInputUI";
import { useTranslation } from "react-i18next";

const StyledList = styled(List)(({ theme }) => ({
  border: `1px solid ${theme.palette.common.border}`,
  borderRadius: theme.shape.borderRadius,
  maxHeight: 300,
  overflowY: "auto",
  paddingTop: 0,
  paddingBottom: 0,
  "& .MuiListItem-root": {
    borderBottom: `1px solid ${theme.palette.common.border}`,
    "&:last-child": {
      borderBottom: `0px solid ${theme.palette.common.border}`,
    },
  },
}));

const DeleteConfirmDialog = (props) => {
  const { t } = useTranslation();
  const {
    onClose,
    open,
    title,
    subTitle,
    selectedItem = [],
    validationText = null,
    label = "",
  } = props;

  const [text, setText] = React.useState("");

  const pathDisabled = useMemo(
    () => (!!validationText ? text !== validationText : false),
    [text, validationText],
  );

  const handleClose = () => {
    onClose(null);
  };

  const handleDeleteClick = (value) => {
    onClose("submit");
  };

  return (
    <StyledDialog onClose={handleClose} open={open}>
      <DialogTitle>
        <IconBackgroundDelete>
          <DeleteIcon sx={{ color: "#BC1B06" }} />
        </IconBackgroundDelete>
        <IconButton
          sx={{ position: "absolute", top: 16, right: 16 }}
          onClick={handleClose}
          aria-label={t("close")}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ width: 400, paddingTop: "0 !important" }}>
        <Typography variant="h4" gutterBottom>
          {title}
        </Typography>
        <Typography sx={{ color: "#475467" }} gutterBottom>
          {subTitle}
        </Typography>
        {selectedItem.length ? (
          <StyledList>
            {selectedItem.map((el) => (
              <ListItem key={el.id}>
                <ListItemAvatar>
                  <DynamicAvatar
                    alt={el.name}
                    src={el.profile_pic}
                    sx={{ width: 40, height: 40 }}
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={el.name}
                  secondary={el.email}
                ></ListItemText>
              </ListItem>
            ))}
          </StyledList>
        ) : null}
        {!!validationText ? (
          <FormInputUI
            label={label}
            height={44}
            required={true}
            id="domain"
            onChange={(e) => setText(e.target.value)}
            value={text}
            placeholder={validationText}
          />
        ) : null}
      </DialogContent>
      <Divider />
      <DialogActions sx={{ padding: "16px 0px !important" }}>
        <FormFooter
          backText={t("cancel")}
          backClick={handleClose}
          pathText={t("delete")}
          pathColor="error"
          fullsize={true}
          handleSubmit={handleDeleteClick}
          pathDisabled={pathDisabled}
        />
      </DialogActions>
    </StyledDialog>
  );
};

export default DeleteConfirmDialog;
